import { ChangeDetectionStrategy, Component, computed, ElementRef, input, model, output, ViewChild } from '@angular/core';
import { UBaseInfraComponent } from '../u-base-infra.component';
import { StyleType } from '../u-button/u-button.component';
import { getIsValidFile } from '@local/ts-infra';
@Component({
  selector: 'u-file-upload',
  templateUrl: './u-file-upload.component.html',
  styleUrls: ['./u-file-upload.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class UFileUploadComponent extends UBaseInfraComponent {
  private readonly ACCEPT_ALL = ['*'];

  label = model<string>();
  styleType = input<StyleType>('fill');
  fontIcon = input<string>();
  styles = input<any>({});

  accept = input<string[]>(this.ACCEPT_ALL);
  multiple = input<boolean>(false);
  maxFileSize = input<number>(5 * 1024 * 1024); // 5MB default
  errorFileTypeMsg = input<string>('Upload failed. Invalid file type.');
  filePreviewUrl = model<string>(null);

  onSelect = output<File | File[]>();
  onError = output<string>();
  onClick = output<void>();
  onCancel = output<void>();

  readonly acceptTypesString = computed(() => {
    const acceptTypes = this.accept();
    if (!acceptTypes || !Array.isArray(acceptTypes) || acceptTypes.length === 0) {
      return '';
    }
    if (acceptTypes.length === 1 && acceptTypes[0] === '*') {
      return '';
    }
    return acceptTypes.join(',');
  });

  @ViewChild('fileInput', { static: true }) fileInput: ElementRef<HTMLInputElement>;

  getIconRef() {
    return null;
  }

  openFileDialog(event?: MouseEvent) {
    event?.preventDefault();
    event?.stopPropagation();
    this.onClick.emit();
    this.fileInput.nativeElement.click();
  }

  onFileSelected(event: Event) {
    const input = event.target as HTMLInputElement;
    const files = input.files;

    if (!files || files.length === 0) {
      return;
    }

    const fileArray = Array.from(files);

    if (this.multiple()) {
      this.onSelect.emit(fileArray);
      return;
    }

    const file = fileArray[0];

    const isValidFile = getIsValidFile(file, this.maxFileSize(), this.accept(), this.errorFileTypeMsg());

    if (!isValidFile.valid) {
      this.onError.emit(isValidFile.errMessage);
    } else {
      this.onSelect.emit(file);
    }

    input.value = '';
  }
}
